function loadMore(loadMoreBtn, sectionIndex) {
  const section = document.querySelector(`.mm-section-slider-products-container[data-section-index="${ sectionIndex }"]`);

  let currentPage = parseInt(loadMoreBtn.getAttribute('data-page'), 10);
  const nextPage = currentPage + 1;
  const totalPages = section.querySelector('.mm-section-slider-products-splide').dataset.pagination;
  
  // Construisez l'URL de la page suivante en utilisant le numéro de la page suivante.
  const nextPageUrl = `${window.location.href.includes('?') ? window.location.href + '&page=' : window.location.href + '?page='}${nextPage}`;
  
  fetch(nextPageUrl)
      .then(response => response.text())
      .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newProducts = doc.querySelectorAll(`.mm-section-slider-products-container[data-section-index="${ sectionIndex }"] .mm-section-slider-products-splide .splide__slide`);
          const productGrid = section.querySelector('.mm-section-slider-products-splide .splide__list');
          
          // Ajoutez chaque nouveau produit au conteneur de la grille de produits.
          newProducts.forEach(product => {
              productGrid.appendChild(product);
          });
          
          // Mettez à jour l'attribut data-page pour le bouton avec le numéro de la nouvelle page.
          loadMoreBtn.setAttribute('data-page', nextPage);
          
          // Cachez le bouton si vous êtes à la dernière page.
          if (nextPage >= totalPages) {
              loadMoreBtn.style.display = 'none';
          }
          // Relancez ici votre fonction pour initialiser les sliders sur les nouvelles cartes produits
      })
      .catch(error => {
          console.error('Error loading more products:', error);
      });
    
}